import React from "react";
import { Link ,useNavigate} from "react-router-dom";
import { CartState } from "../Context/Context";
import "../Styles/ProductItems.css";

export default function ProductItems({item}) {
  const {
    state: { cart },
    dispatch,
  } = CartState();

  let navigate = useNavigate();



  return (
      <Link to="/productdetails"
          state={{item:item}}
          >
    <div className="caard" >
      <div className="caard-body">
         <img src={item.image} alt="" className="caard-img"/>
        <h5 className="caard-title">{item.title}</h5>
        <p className="caard-price">₹ {item.price}</p> 
        <p className="caard-sp">₹ {item.specialprice}</p>
      </div>
        

        

        {/* <div className="cart-btn">
          {cart.some((p) => p.title === props.title) ? (
            <button
              onClick={() => {
                dispatch({
                  type: "REMOVE_FROM_CART",
                  payload: props,
                });
              }}
              style={{ backgroundColor: "#032044" }}
            >
              REMOVE FROM CART
            </button>
          ) : (
            <button
              onClick={() => {
                dispatch({
                  type: "ADD_TO_CART",
                  payload: props,
                });
              }}
              disabled={cart.length === 12}
              style={{ backgroundColor: cart.length === 12 ? "red" : "grey" }}
            >
              {cart.length === 12 ? "CART LIMIT REACHED " : "ADD TO CART"}
            </button>
          )}
        </div> */}
    </div>
      </Link>
  );
}
